import styled from "styled-components"

export const Section = styled.section`
  background: #1a1a1a;
  margin-left: -1px;
  margin-right: -1px;
  padding: 50px 0px;
  @media (min-width: 999px) {
    padding: 200px 0px;
  }
`

export const Container = styled.div`
  max-width: 800px;
  margin: auto;
  @media (max-width: 999px) {
    padding: 4em;
  }
`

export const Form = styled.form`
  padding: 16px 0;
`

export const Input = styled.input`
  border: none;
  background: #000;
  color: white;
  margin-bottom: 8px;
  padding: 8px 8px;
  display: block;
  width: 100%;
  &[disabled] {
    opacity: 0.3;
  }
  &::placeholder {
    color: #FFFFFF;
  }
`

export const Title = styled.h2`
  font-family: Oswald, sans-serif !important;
  padding: 8px 0;
  margin: 0;
  color: #FFFFFF;
  text-align: center;
`
export const Paragraph = styled.p`
  font-size: 16px;
  color: #ffffff;
  text-align: center;
`

export const Error = styled.span`
  color: red;
  font-size: 14px;
`
export const Success = styled.span`
  color: green;
  font-size: 14px;
`
